export const useAuth = {
    async login(form){
        //const csrf = useCsrf();
        return await useFetch("/api/auth/login", {
            method: 'POST', cache: false, body: form,
            credentials: 'include',
            onRequest({ request, options }) {
               //options.headers.set(csrf.headerName, csrf.csrf)
            }
        });
    },
    async register(form) {
        //const csrf = useCsrf();
        return await useApiFetchData(`/auth/register`, {
            method: 'POST', cache: false, body: form,
            onRequest({ request, options }) {
                //options.headers.set(csrf.headerName, csrf.csrf)
            }
        });
    },
    async sendOTP(form) {
        //const csrf = useCsrf();
        return await useApiFetchData(`/auth/sendOTP`, {
            method: 'POST', cache: false, body: form,
            onRequest({ request, options }) {
                //options.headers.set(csrf.headerName, csrf.csrf)
            }
        });
    },
    async verifyOTP(form) {
        //const csrf = useCsrf();
        return await useApiFetchData(`/auth/verifyOTP`, {
            method: 'POST', cache: false, body: form,
            onRequest({ request, options }) {
                //options.headers.set(csrf.headerName, csrf.csrf)
            }
        });
    },    
    async saveCredential(form){
        if (!window.PasswordCredential) {
            return Promise.resolve(null);
        }
        const cred = new window.PasswordCredential(form);
        navigator.credentials.store(cred);
        return cred;
    }
}